/*
  fl-reviews.js (22 Oct). Hides the placeholder body text "No written review provided" on
  rating-only reviews imported into Judge.me. Judge.me renders and paginates its widgets after
  page load, so this runs on DOMContentLoaded and again (debounced) whenever the DOM changes.
  It only hides an element whose whole trimmed text is the placeholder, so real reviews are never touched.
*/
(function () {
  'use strict';
  try {
    var PLACEHOLDER = 'no written review provided';
    var HIDDEN_ATTR = 'data-fl-empty-review';
    // Known Judge.me review body wrappers (legacy jdgm and newer jm widgets, carousels, popups).
    var BODY_SELECTORS = [
      '.jdgm-rev__body',
      '.jdgm-review-content__body-content',
      '.jm-review-body-wrapper',
      '.jm-review-item__body',
      '.jm-review-content__body',
      '.jdgm-carousel-item__review-body',
      '.jdgm-rev-widg__body',
      '.jdgm-all-reviews__body',
      '.jdgm-quotes__body',
      '.jdgm-popup-widget__body',
      '.jdgm-medals__body'
    ].join(',');

    function norm(s) {
      return (s || '').replace(/\s+/g, ' ').trim().replace(/\.+$/, '').trim().toLowerCase();
    }

    function isPlaceholder(el) {
      return norm(el.textContent) === PLACEHOLDER;
    }

    function hide(el) {
      if (!el || el.getAttribute(HIDDEN_ATTR) === '1') return;
      el.setAttribute(HIDDEN_ATTR, '1');
      el.style.setProperty('display', 'none', 'important');
    }

    // Climb from a matching element to the largest ancestor whose text is still only the placeholder,
    // stopping at review item level so stars, names and dates stay visible.
    function topMatch(el) {
      var cur = el;
      while (cur.parentElement && cur.parentElement !== document.body && isPlaceholder(cur.parentElement)) {
        cur = cur.parentElement;
      }
      return cur;
    }

    function scan(root) {
      root = root || document.body;
      if (!root || !root.querySelectorAll) return;

      // 1. Known body wrappers.
      var bodies = root.querySelectorAll(BODY_SELECTORS);
      for (var i = 0; i < bodies.length; i++) {
        if (isPlaceholder(bodies[i])) hide(bodies[i]);
      }

      // 2. Fallback for unknown or changed class names: find the text itself inside Judge.me markup.
      if ((root.textContent || '').toLowerCase().indexOf('written review') === -1) return;
      var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
        acceptNode: function (n) {
          return norm(n.nodeValue) === PLACEHOLDER ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
        }
      });
      var nodes = [];
      while (walker.nextNode()) nodes.push(walker.currentNode);
      for (var j = 0; j < nodes.length; j++) {
        var el = nodes[j].parentElement;
        if (!el || el.closest('[' + HIDDEN_ATTR + ']')) continue;
        if (!el.closest('[class*="jdgm"], [class*="jm-"], [id*="judgeme"]')) continue;
        if (el.closest('script, style, textarea, noscript')) continue;
        hide(topMatch(el));
      }
    }

    var timer = null;
    function schedule() {
      if (timer) return;
      timer = setTimeout(function () {
        timer = null;
        try { scan(document.body); } catch (e) {}
      }, 150);
    }

    function start() {
      try { scan(document.body); } catch (e) {}
      if (!('MutationObserver' in window) || !document.body) return;
      new MutationObserver(function (records) {
        for (var k = 0; k < records.length; k++) {
          if (records[k].addedNodes && records[k].addedNodes.length) { schedule(); return; }
          if (records[k].type === 'characterData') { schedule(); return; }
        }
      }).observe(document.body, { childList: true, subtree: true, characterData: true });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }
  } catch (err) {
    if (window.console && console.warn) console.warn('fl-reviews', err);
  }
})();
